import _ from 'underscore'
import MonotonicCubicSpline from '../vendors/splines'

const HEIGHT_SCALES = [
  [150, 200, 240, 320, 400, 480, 600, 768, 864],
  [0.1, 0.17, 0.26, 0.42, 0.55, 0.57, 0.7, 0.87, 1]
]

const WIDTH_SCALES = [
  [150, 200, 320, 480, 600, 640, 800, 1024, 1152],
  [0.1, 0.17, 0.26, 0.42, 0.55, 0.57, 0.7, 0.87, 1]
]

const H_SPLINE = new MonotonicCubicSpline(HEIGHT_SCALES[0], HEIGHT_SCALES[1])
const W_SPLINE = new MonotonicCubicSpline(WIDTH_SCALES[0], WIDTH_SCALES[1])

const W_MAX = _.max(WIDTH_SCALES[0])
const W_MIN = _.min(WIDTH_SCALES[0])

const H_MAX = _.max(HEIGHT_SCALES[0])
const H_MIN = _.min(HEIGHT_SCALES[0])

export function getScale (width = window.innerWidth, height = window.innerHeight) {
  let heightScale, widthScale

  if (width < W_MIN) {
    widthScale = WIDTH_SCALES[1][0]
  } else if (width > W_MAX) {
    widthScale = _.last(WIDTH_SCALES[1])
  } else {
    widthScale = W_SPLINE.interpolate(width)
  }

  if (height < H_MIN) {
    heightScale = HEIGHT_SCALES[1][0]
  } else if (height > H_MAX) {
    heightScale = _.last(HEIGHT_SCALES[1])
  } else {
    heightScale = H_SPLINE.interpolate(height)
  }

  return _.min([heightScale, widthScale])
}
